/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { City } from '@app/settings/cities/cities.model';

export class Venue extends Model {
  id: number;
  name: string;
  note: string;
  address: string;
  lat: number;
  long: number;
  active: boolean;
  city?: City;
  pivot?: any;
  translations?: any;
  founded_at: string;
  rooms_count: number;
  visitors_per_year: string;
  area: string;
  distance_to_center: number;
  distance_to_airport: number;
  distance_to_tr_point: number;
  distance_to_tr_point_name: string;
  capacity: string;
  parking: string;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.city) {
      this.city = new City().deserialize(input.city);
    }
    return this;
  }
}
